import { render, staticRenderFns } from "./ShowBulkCertificate.vue?vue&type=template&id=56b6b5a2&scoped=true"
import script from "./ShowBulkCertificate.vue?vue&type=script&lang=js"
export * from "./ShowBulkCertificate.vue?vue&type=script&lang=js"
import style0 from "./ShowBulkCertificate.vue?vue&type=style&index=0&id=56b6b5a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b6b5a2",
  null
  
)

export default component.exports